const WMS_SIGN_IN_PATH = '/auth/sign-in'
let isLoggingOut = false

export function redirectToWmsSignIn({ logout = false }: { logout?: boolean } = {}): void {
  // Clearing local auth can make the route guard issue a second redirect.
  isLoggingOut ||= logout
  const url = new URL(WMS_SIGN_IN_PATH, import.meta.env.VITE_WMS_PUBLIC_URL)
  url.searchParams.set('legacyReturnOrigin', window.location.origin)
  if (isLoggingOut) url.searchParams.set('logout', 'true')
  window.location.replace(url.href)
}
